import { render, staticRenderFns } from "./DigitInput.vue?vue&type=template&id=5e0bb7d4&scoped=true"
import script from "./DigitInput.vue?vue&type=script&lang=js"
export * from "./DigitInput.vue?vue&type=script&lang=js"
import style0 from "./DigitInput.vue?vue&type=style&index=0&id=5e0bb7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0bb7d4",
  null
  
)

export default component.exports